import React, { useEffect, useState } from "react";
import { object, array, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LinkTag from "../../molecules/link-tag";
import Headline from "../../atoms/headline";
import CustomStoryCard1 from "../../molecules/custom-story-card1";
import CustomStoryCard3 from "../../molecules/custom-story-card3";
import DoubleRightIcon from "../../atoms/icons/double-angle-right";

import { getAllSectionsStories, getCollectionSlug } from "../../utils/utils";

import "./bigWithSmallStoryMobile.m.css";

const BigWithSmallStoryMobile = ({ collection, sections, externalStories, isExternalStory, externalSlug }) => {
  if (!(collection && collection.items)) {
    return null;
  }

  const storiesArray = externalStories || collection.items;

  useEffect(() => {
    if (window.location.pathname === "/all-sections") {
      setSectionName("All Sections");
    }
  }, []);

  const [sectionName, setSectionName] = useState("");
  const stories = getAllSectionsStories(sectionName, collection, storiesArray, 0);

  if (!stories.length) {
    return null;
  }

  const [firstStory, ...remainingStories] = stories.splice(0, 3);

  return (
    <div styleName="wrapper" className="big-with-small-story-mobile" id={collection.slug}>
      <div styleName="headline">
        <LinkTag
          href={isExternalStory ? externalSlug : getCollectionSlug(collection, sections)}
          isExternalStory={isExternalStory}
        >
          <Headline text={collection.name || ""} headerType={14} />
        </LinkTag>
        <LinkTag
          href={isExternalStory ? externalSlug : getCollectionSlug(collection, sections)}
          isExternalStory={isExternalStory}
        >
          <DoubleRightIcon />
        </LinkTag>
      </div>

      <CustomStoryCard1
        story={firstStory}
        headerType={2}
        showAuthorName={true}
        showSummary={false}
        isExternalStory={isExternalStory}
      />

      <div styleName="stories">
        {remainingStories.map((item, index) => (
          <CustomStoryCard3
            story={item}
            key={index}
            headerType={3}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            isExternalStory={isExternalStory}
            showHeadlineIcon
          />
        ))}
      </div>
    </div>
  );
};

BigWithSmallStoryMobile.propTypes = {
  collection: object.isRequired,
  sections: array,
  externalStories: array,
  isExternalStory: bool,
  externalSlug: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
});

export default connect(mapStateToProps, null)(BigWithSmallStoryMobile);
